import { SystemMenuInsert, SystemMenuDelete, SystemMenuUpdate, SystemMenuGetById, SystemMenuGetList, SystemMenuGetPageList } from "@/api/systemmenu/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    SystemMenuInsert(context, payload) {
        return new Promise((resolve, reject) => {
            
            
            SystemMenuInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    SystemMenuUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            SystemMenuUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    SystemMenuGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            SystemMenuGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    SystemMenuGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            SystemMenuGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    SystemMenuGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            SystemMenuGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}